import budgetTemplates from "@/store/modules/budgetTemplates";
// import budgetTracking from "@/store/modules/budgetTracking";

export default {
  namespaced: true,
  modules: {
    budgetTemplates,
    // budgetTracking,
  },
};
